import { server } from "../api";
import axios from "axios";

// 與 InfraredCamera.js 相同的逾時與錯誤訊息處理慣例
const DEFAULT_TIMEOUT = 20000;
const HEAVY_TIMEOUT = 30000;

const http = axios.create({ timeout: DEFAULT_TIMEOUT });

const describeError = (error, label) => {
  if (error?.code === "ECONNABORTED") return `${label}：請求逾時，伺服器沒有在時限內回應`;
  if (error?.code === "ERR_NETWORK" || !error?.response) return `${label}：無法連線到伺服器`;
  const { status, data } = error.response;
  if (data && typeof data.message === "string" && data.message) return `${label}：${data.message}`;
  if (status === 504) return `${label}：伺服器處理逾時 (504)`;
  return `${label}：HTTP ${status}`;
};

const request = async (config, label) => {
  try {
    const response = await http(config);
    return response.data;
  } catch (error) {
    console.error(`[SaltFogCamera] ${label} 失敗:`, error);
    if (error && typeof error === "object") error.uiMessage = describeError(error, label);
    throw error;
  }
};

/** 取得機具座標、選站、目前溫濕度、今日高低溫 */
const GetData = async (machineID) =>
  request({ method: "get", url: `${server}api/saltfog/${machineID}` }, "載入氣象資料");

/** 附近氣象站 → { device: {latitude, longitude, coord_is_default}, stations: [...] } */
const GetNearbyStations = async (machineID, limit = 30) =>
  request(
    { method: "get", url: `${server}api/saltfog/${machineID}/nearby-stations`, params: { limit } },
    "載入氣象站"
  );

/** 設定氣象站 */
const SelectStation = async (machineID, stationId) =>
  request(
    {
      method: "post",
      url: `${server}api/saltfog/${machineID}/select-station`,
      data: { station_id: stationId },
    },
    "選站"
  );

/**
 * 圖表資料（每小時一筆，最高 / 最低溫為近 window 小時的滑動視窗）
 * @param {{range?: '24h'|'72h'|'7d'|'30d', start?: string, end?: string, window?: 2|3|6}} opts
 */
const GetChartData = async (machineID, { range, start, end, window = 2 } = {}) => {
  const params = start && end ? { start, end, window } : { range: range || "72h", window };
  return request(
    {
      method: "get",
      url: `${server}api/saltfog/${machineID}/chart-data`,
      params,
      timeout: HEAVY_TIMEOUT,
    },
    "載入圖表資料"
  );
};

export default { GetData, GetNearbyStations, SelectStation, GetChartData };